class Popover {
    constructor(anchorElement, options) {
        this.options = $.extend({}, Popover.defaults, options);

        this.anchor = $(anchorElement);
        this.popover = $('<div class="popover"/>');
        this.arrow = $('<div class="popover-arrow"/>').appendTo(this.popover);
        this.content = $('<div class="popover-content"/>').appendTo(this.popover);
        this.id = new Date().getUTCMilliseconds() + Math.random();

        this.popover.on('click', this.onClick.bind(this));
    }
    html(content) {
        this.content.html(content);
        return this;
    }
    append(content) {
        this.content.append(content);
        return this;
    }
    prepend(content) {
        this.content.prepend(content);
        return this;
    }
    find(selector) {
        return this.content.find(selector);
    }
    show() {
        if (Popover.active == this) return;
        if (Popover.active) Popover.active.hide();
        Popover.active = this;
        this.popover.removeClass('closed visible').appendTo($('body'));
        this.position();
        this.popover.addClass('visible');
        var inputs = this.content.find('input');
        if (inputs.length > 0) inputs.first().focus();

        this.onResizeEvent = this.onResize.bind(this);
        this.onMouseDownEvent = this.onMouseDown.bind(this);
        this.onDocMouseDownEvent = this.onDocMouseDown.bind(this);
        this.onDocKeyDownEvent = this.onDocKeyDown.bind(this);
        $(window).on('resize', this.onResizeEvent);
        $(document).on('mousedown', this.onDocMouseDownEvent);
        this.popover.on('mousedown', this.onMouseDownEvent);
        $(document).on('keydown', this.onDocKeyDownEvent);
    }
    hide() {
        if (Popover.active == this) Popover.active = null;
        var popover = this.popover;
        popover.addClass('closed');
        setTimeout( () => popover.remove(), 300);

        if (this.onResizeEvent) $(window).off('resize', this.onResizeEvent);
        if (this.onMouseDownEvent) this.popover.off('mousedown', this.onMouseDownEvent);
        if (this.onDocMouseDownEvent) $(document).off('mousedown', this.onDocMouseDownEvent);
        if (this.onDocKeyDownEvent) $(document).off('mousedown', this.onDocKeyDownEvent);

        if (this.options.onClose) this.options.onClose.call(this);
    }
    toggle() {
        if (Popover.active == this) this.hide();
        else this.show();
    }
    position() {
        var anchorRect = this.anchor[0].getBoundingClientRect();
        var popoverRect = this.popover[0].getBoundingClientRect();

        var x = anchorRect.left + $(window).scrollLeft() + anchorRect.width / 2;
        var y = anchorRect.top + $(window).scrollTop() + anchorRect.height / 2;
        var xPadding = 40;
        var yPadding = 40;

        var verticalPossible = (anchorRect.left + anchorRect.width / 2 - popoverRect.width / 2 > xPadding )
                            && (anchorRect.left + anchorRect.width / 2 + popoverRect.width / 2 < window.innerWidth - xPadding);

        if (verticalPossible && (anchorRect.top + anchorRect.height + popoverRect.height < window.innerHeight - yPadding)) {
            var pos = 'below';
            this.popover.addClass(pos).removeClass('above left right');
            y += anchorRect.height / 2;
        } else if (verticalPossible && (anchorRect.top - popoverRect.height > yPadding)) {
            var pos = 'above';
            this.popover.addClass(pos).removeClass('below left right');
            y -= anchorRect.height / 2;
        } else if (anchorRect.left + anchorRect.width + popoverRect.width < window.innerWidth - xPadding) {
            var pos = 'right';
            this.popover.addClass(pos).removeClass('above below left');
            x += anchorRect.width / 2;
        } else {
            var pos = 'left';
            this.popover.addClass(pos).removeClass('above below right');
            x -= anchorRect.width / 2;
        }

        if (pos === 'left' || pos === 'right') {
            var top = y - popoverRect.height / 2;
            if (top < yPadding) top = Math.min(y - 15, yPadding);
            else if (top + popoverRect.height > window.innerHeight - yPadding) top = Math.max(window.innerHeight - popoverRect.height - yPadding, y - popoverRect.height + 15);
            this.popover.css({ left: x, top: top });
            popoverRect = this.popover[0].getBoundingClientRect();
            var anchorTop = anchorRect.top + anchorRect.height / 2 - popoverRect.top;
            this.arrow.css('top', anchorTop);
            this.popover.css('transform-origin', (pos === 'right' ? '0%' : '100%') + ' ' + anchorTop + 'px');
        } else {
            this.popover.css({ left: x, top: y, transformOrigin: null });
            this.arrow.css('top', null);
        }
    }
    startLoadingContent() {
        this.content.html('<div class="loader"></div>');
    }
    stopLoadingContent() {
        this.content.html('');
    }
    onResize() {
        this.position();
        setTimeout(this.position.bind(this), 300); // In case of animations
    }
    onClick(event) {
        event.stopPropagation();
    }
    onDocMouseDown(event) {
        if (event.target) {
            if (event.target === this.anchor[0]) return;
            else if ($(event.target).closest(this.anchor).length > 0) return;
        }
        this.hide();
    }
    onMouseDown(event) {
        event.stopPropagation();
    }
    onDocKeyDown(event) {
        switch (event.key) {
            case $.key.escape:
                this.hide();
                break;
            default:
                return;
        }
        event.preventDefault();
        event.stopPropagation();
    }
}

Popover.defaults = {
    // Callback fired on popover closure
    onClose: null
};
